import ProfileCard from "components/profile/ProfileCard"
import SingleEventCard from "components/profile/SingleEventCard"
import Header from 'components/profile/Header';
import { useState, useEffect } from 'react';
import axios from "axios";
import AddEventForm from "../components/profile/AddEventForm"
import {getUserFromLocalStorage} from "../helper/helpingFunctions"

export default function Profile(props) {
    let [events, setEvents] = useState([]);
    let eventsFromDb;
    useEffect(() => {
        async function fetchData() {
          // You can await here
          eventsFromDb = await axios.get(process.env.REACT_APP_API + "/events");
          setEvents(eventsFromDb.data)
          // ...
        }
        fetchData();
      }, []); // Or [] if effect doesn't need props or state
    
    if(!getUserFromLocalStorage()) {
        return props.history.push("/")
    }
    return (
        <>
            <main>
                <Header />
                <ProfileCard />
                {/* <ProfileCard /> */}
                {events.map((singleEvent, i) => {
                    return <SingleEventCard key={i} info={singleEvent} history={props.history} />
                })}
            </main>
        </>
    );
}
